angular.module('unica_wiki.wiki_controllers')

.controller('WikiDetailController', function(
	$rootScope, $scope, $state, $stateParams
) {

	$scope.pageTitle = 'Visualizza Dato';

	$rootScope.getWiki( $stateParams.id );

})

;